<template>
  <div class="loadingoverlay">
    <div class="lds-dual-ring"></div>
  </div>
</template>
<script>
export default {};
</script>
<style scoped>
.loadingoverlay {
  position: fixed;
  background: #000000;
  opacity: 0.6;
  width: 100%;
  height: 100%;
  top: 0;
  z-index: 999999;
}
.lds-dual-ring {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 64px;
  height: 64px;
}
.lds-dual-ring::after {
  content: " ";
  display: block;
  width: 46px;
  height: 46px;
  margin: 1px;
  border-radius: 50%;
  border: 5px solid #329bcdff;
  border-color: #329bcdff transparent #329bcdff transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}
@keyframes lds-dual-ring {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
